import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToastrService as ToasterService } from 'ngx-toastr';
import { BehaviorSubject, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { Pagination } from '@sd-portal/shared/models';
import { untilViewDestroyed } from '@sd-portal/shared/rxjs';

import { AuditLogLite, FleetAuditTail } from '../+models/fleet-audit.model';
import { FleetAuditService } from '../fleet-audit.service';

@Component({
  selector: 'sd-portal-fleet-overview-audit',
  templateUrl: './fleet-overview-audit.component.html',
  styleUrls: ['./fleet-overview-audit.component.scss']
})
export class FleetOverviewAuditComponent implements OnInit, OnDestroy {
  tails: FleetAuditTail[] = [];
  tailsLoading = false;
  tailsPagination$ = new BehaviorSubject<Pagination>(new Pagination());

  selectedTail: FleetAuditTail | null = null;
  logs: AuditLogLite[] = [];
  logsLoading = false;
  logsPagination$ = new BehaviorSubject<Pagination>(new Pagination());

  constructor(
    private readonly fleetAuditService: FleetAuditService,
    private readonly toasterService: ToasterService
  ) {}

  ngOnInit() {
    this.loadTails(1, 10);
  }

  ngOnDestroy() {}

  loadTails(pageNumber: number, pageSize: number) {
    this.tailsLoading = true;
    this.fleetAuditService
      .getTails(pageNumber, pageSize)
      .pipe(
        untilViewDestroyed(this),
        catchError(() => {
          this.tailsLoading = false;
          this.toasterService.error('Failed to retrieve fleet audit tails');
          return EMPTY;
        })
      )
      .subscribe(res => {
        this.tailsLoading = false;
        this.tails = res.resultSet || [];
        this.tailsPagination$.next({
          ...new Pagination(),
          totalCount: res.totalCount,
          pageSize: res.pageSize,
          pageNumber: res.pageNumber
        });
      });
  }

  onTailsPageChange(pagination: Pagination) {
    this.loadTails(pagination.pageNumber, pagination.pageSize);
  }

  selectTail(tail: FleetAuditTail) {
    this.selectedTail = tail;
    this.logs = [];
    this.loadLogs(1, 10);
  }

  loadLogs(pageNumber: number, pageSize: number) {
    if (!this.selectedTail) {
      return;
    }
    this.logsLoading = true;
    this.fleetAuditService
      .getTailLogs(this.selectedTail.id, pageNumber, pageSize)
      .pipe(
        untilViewDestroyed(this),
        catchError(() => {
          this.logsLoading = false;
          this.toasterService.error('Failed to retrieve audit logs for tail');
          return EMPTY;
        })
      )
      .subscribe(res => {
        this.logsLoading = false;
        this.logs = res.resultSet || [];
        this.logsPagination$.next({
          ...new Pagination(),
          totalCount: res.totalCount,
          pageSize: res.pageSize,
          pageNumber: res.pageNumber
        });
      });
  }

  onLogsPageChange(pagination: Pagination) {
    this.loadLogs(pagination.pageNumber, pagination.pageSize);
  }

  tailTrackByFn(_index: number, tail: FleetAuditTail) {
    return tail.id;
  }

  logTrackByFn(_index: number, log: AuditLogLite) {
    return log.id;
  }
}
